module.exports = __webpack_public_path__ + "images/pro/img-pro-storage-bg@2x-2d5741e54bbcb789f84f47679c5a1a84.png";